import client from '@/shared/apis/client'
import {
  Action,
  PaginatedActionsResponse,
  CreateActionRequest,
  UpdateActionStatusRequest,
} from '@/features/patient-actions/types/patientActions'

// アクション一覧取得
export const getActions = async (params?: {
  patient?: string
  status?: string
  group?: string
  yakureki?: string
  page?: number
  page_size?: number
}): Promise<PaginatedActionsResponse> => {
  const response = await client.get('/api/patient-actions/', { params })
  return response.data
}

// アクション詳細取得
export const getAction = async (actionId: string): Promise<Action> => {
  const response = await client.get(`/api/patient-actions/${actionId}/`)
  return response.data
}

// アクション作成
export const createAction = async (
  data: CreateActionRequest
): Promise<Action> => {
  const response = await client.post('/api/patient-actions/', data)
  return response.data
}

// アクション更新
export const updateAction = async (
  actionId: string,
  data: Partial<Action>
): Promise<Action> => {
  const response = await client.patch(`/api/patient-actions/${actionId}/`, data)
  return response.data
}

// アクション削除
export const deleteAction = async (actionId: string): Promise<void> => {
  await client.delete(`/api/patient-actions/${actionId}/`)
}

// アクションステータス更新
export const updateActionStatus = async (
  actionId: string,
  data: UpdateActionStatusRequest
): Promise<Action> => {
  const response = await client.post(
    `/api/patient-actions/${actionId}/update_status/`,
    data
  )
  return response.data
}
